import { useTranslation } from 'react-i18next'
import AlertContainer from './AlertContainer'

const SyncFinishedAlert = () => {
  const { t } = useTranslation('dataSync')
  return <AlertContainer type="alert" alertText={t('finished')} alertColor="teal" textSize="var(--spacing-lg)" />
}

export default SyncFinishedAlert
